import focusWithin from "focus-within";

export function initMenu() {
  var $menu = $("nav.main-menu"),
    $burger = $menu.find(".burger"),
    $button = $menu.find(".bouton-menu");

  // Polyfill pour focus-within, sur lequel on base notre menu
  focusWithin(document);

  $burger.click(function () {
    var menuIsOpen = $burger.hasClass("open");

    if (!menuIsOpen) {
      $button.focus();
    }
  });

  $menu.focusin(function () {
    var menuIsOpen = $burger.hasClass("open");

    if (!menuIsOpen) {
      $burger.addClass("open");
    }
  });
  $menu.focusout(function () {
    var menuIsOpen = $burger.hasClass("open");

    if (menuIsOpen) {
      // Quand on clique sur le burger alors que le menu est ouvert, on a
      // d'abord un focusout puis un click. C'est pour ça qu'on attend un
      // peu avant d'enlever la classe, pour éviter qu'elle ne soit déjà
      // plus là quand le click est émis, et que le burger le confonde
      // avec un clic d'ouverture.
      setTimeout(function () {
        $burger.removeClass("open");
      }, 150);
    }
  });
}
